import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ZoomMtg } from "@zoom/meetingsdk";
import { AuthContext } from "../context/AuthContext";
import { getApi } from "../services/api";
import { BASE_URL } from "../utils/constants";
import { toast } from "react-toastify";

function Room() {
	const { classroomId } = useParams();
	const { user } = useContext(AuthContext);
	const navigate = useNavigate();
	const leaveUrl = BASE_URL;

	const getSignature = async () => {
		import("/node_modules/@zoom/meetingsdk/dist/ui/zoom-meetingsdk.css");
		ZoomMtg.preLoadWasm();
		ZoomMtg.prepareWebSDK();
		try {
			const res = await getApi(`/session/${classroomId}`);
			if (!res?.signature || !res?.password || !res?.meetingNumber) {
				toast.error("Classroom has not started");
				setTimeout(() => navigate("/studentProfile"), 1000);
				throw new Error("Invalid classroom session");
			}
			const { signature, password, sdkKey, meetingNumber } = res;
			if (!res?.signature || !res?.password || !res?.meetingNumber) {
				toast.error("Classroom has not started");
				setTimeout(
					() =>
						user?.role === "student"
							? navigate("/studentProfile")
							: navigate("/teachersProfile"),
					1000
				);
				throw new Error("Invalid classroom session");
			}

			startMeeting({
				signature,
				password,
				sdkKey,
				meetingNumber,
				userName: user?.fullName || "Demo name",
				userEmail: user?.email || "Demo email",
			});
		} catch (e) {
			console.error(e);
		}
	};

	function startMeeting({
		signature,
		password,
		sdkKey,
		meetingNumber,
		userName,
		userEmail,
	}) {
		const zoomContainer = document.getElementById("zmmtg-root");
		zoomContainer.style.display = "block";
		zoomContainer.style.zIndex = 20;
		ZoomMtg.init({
			leaveUrl: leaveUrl,
			patchJsMedia: true,
			leaveOnPageUnload: true,
			success: (success) => {
				ZoomMtg.join({
					signature: signature,
					sdkKey: sdkKey,
					meetingNumber: meetingNumber,
					passWord: password,
					userName: userName,
					userEmail: userEmail,
					success: (success) =>
						console.log("Successfully joined the meeting"),
					error: (error) =>
						console.error("There was an error joining the meeting"),
				});
			},
			error: (error) => {
				console.error(error);
			},
		});
	}
	useEffect(() => {
		getSignature();
	}, []);

	return (
		<>
			<div className="App">
				{/* <main>
					<h1>Zoom Meeting SDK Sample React</h1>
					<button
						onClick={getSignature}
						className="p-5 bg-blue-300 rounded-md cursor-pointer"
					>
						Join Meeting
					</button>
				</main> */}
			</div>
		</>
	);
}

export default Room;
